import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "akkas-consent";

// Analytics (Google Analytics / Meta Pixel) would be initialised here — only
// after explicit consent. No trackers load unless the visitor accepts.
function loadAnalytics() {
  if (window.__akkasAnalyticsLoaded) return;
  window.__akkasAnalyticsLoaded = true;
  // Placeholder: inject GA/Meta scripts here once measurement IDs are provided.
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setVisible(true);
    else if (saved === "accepted") loadAnalytics();
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    if (value === "accepted") loadAnalytics();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-5 right-5 sm:left-6 sm:right-auto z-[70] sm:max-w-sm bg-[#121110] text-[#FBF9F5] p-6 sm:p-7 shadow-2xl border border-white/10"
        >
          <div className="flex items-center gap-3 mb-4">
            <Cookie className="h-5 w-5 text-[#C5A880]" strokeWidth={1.25} />
            <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/60">
              Cookies &amp; Consent
            </span>
          </div>
          <p className="text-sm leading-relaxed font-light text-white/70 mb-6">
            We use cookies and similar technologies for analytics and marketing — only with your
            consent. You may accept or decline at any time.
          </p>
          <div className="flex items-center gap-3">
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="hairline-btn bg-[#FBF9F5] text-[#121110] px-6 py-3 font-mono-accent text-[10px] uppercase tracking-[0.25em] hover:bg-[#C5A880]"
            >
              Accept all
            </button>
            <button
              data-testid="cookie-decline-button"
              onClick={() => choose("declined")}
              className="link-underline font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/60 hover:text-[#FBF9F5] pb-1"
              style={{ backgroundImage: "linear-gradient(#FBF9F5,#FBF9F5)" }}
            >
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
